import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const projectTrackingServices = {
  getProjectTrackingData,
  addNewProjectTracking,
  updateProjectTracking,
  softDeleteRestoreProjectTracking,
  deleteProjectTrackingData,
};

async function addNewProjectTracking(userData) {
  const response = await fetch(
    `${config.API_URL}addNewProjectTracking`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateProjectTracking(userData) {
  const response = await fetch(
    `${config.API_URL}updateProjectTracking`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreProjectTracking(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreProjectTracking`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteProjectTrackingData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteProjectTrackingData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getProjectTrackingData(status = "all", searchData = "", page, length, extraQuery = {}) {
  const query = new URLSearchParams();
  query.append("search", searchData || "");

  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  Object.entries(extraQuery || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const response = await fetch(
    `${config.API_URL}getProjectTrackingData/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );

  const data = await response.json();
  return data;
}
